<template>
  <v-dialog v-model="isOpen"
    persistent
    scrollable
    content-class="user-pref-dialog">
    <v-card class="device-dialog">
      <v-toolbar class="escalon-dialog-header" height="35">
        <img
          class="modal-axis-logo mr-2"
          :src="require('../../assets/' + coloredLogo)" />
        <span class="modal-title">{{modalTitle}}</span>
        <v-spacer />
        <v-btn text @click="clearDataAndClose()">
          <v-avatar size="20" class="mr-2">
            <img :src="require('../../assets/' + coloredAssetUrls.close)" />
          </v-avatar>Close
        </v-btn>
      </v-toolbar>
      <v-card-text style="min-height: 340px;">
        <v-container fluid grid-list-md>
          <v-layout wrap>
            <v-flex md12>
              <div class="error">{{error}}</div>
            </v-flex>
            <v-flex md3>
              <div>
                <label class="modal-label">Device Type*</label>
              </div>
              <v-text-field class="inputField"
                type="text"
                name="device.devType"
                v-model="device.devType"
                v-validate="{ required: true, regex: this.lengthRegex }"
                autocomplete="off"
                solo />
            </v-flex>
            <v-flex md3>
              <div>
                <label class="modal-label">Device Name*</label>
              </div>
              <v-text-field class="inputField"
                type="text"
                name="device.devName"
                v-model="device.devName"
                v-validate="{ required: true, regex: this.lengthRegex }"
                autocomplete="off"
                solo />
            </v-flex>
            <v-flex md3>
              <div>
                <label class="modal-label">Exam Type (Dev Proc)*</label>
              </div>
              <v-text-field class="inputField"
                type="text"
                name="device.devProc"
                v-model="device.devProc"
                autocomplete="off"
                v-validate="{ required: true, regex: this.lengthRegex }"
                solo />
            </v-flex>
            <v-flex md3>
              <div>
                <label class="modal-label">Device Description*</label>
              </div>
              <v-text-field
                class="inputField"
                type="text"
                name="device.devDescrition "
                v-model="device.devDescrition "
                v-validate="{ required: true, regex: new RegExp(/^(?=.{1,200}$)/) }"
                autocomplete="off"
                solo/>
            </v-flex>
            <v-flex md3>
              <div>
                <label class="modal-label">Is Active</label>
              </div>
              <select-with-button
                class="inputField"
                v-model="device.isActive"
                :items="TRUE_OR_FALSE"
                name="device.isActive"/>
            </v-flex>
            <v-flex md3>
              <div>
                <label class="modal-label">Ignore Rotation</label>
              </div>
              <select-with-button
                class="inputField"
                v-model="device.ignoreRotation"
                :items="TRUE_OR_FALSE"
                name="device.ignoreRotation"/>
            </v-flex>
            <v-flex md3>
              <div>
                <label class="modal-label">Order By Laterality</label>
              </div>
              <select-with-button
                class="inputField"
                v-model="device.orderByLaterality"
                :items="TRUE_OR_FALSE"
                name="device.orderByLaterality"/>
            </v-flex>
            <v-flex md3>
              <div>
                <label class="modal-label">Default Zoom Factor</label>
              </div>
              <v-text-field
                class="inputField"
                type="text"
                name="device.defaultZoomFactor"
                v-model="device.defaultZoomFactor"
                v-validate="{ regex: new RegExp(/^(?=.*[0-9]+.[0-9]+$)/) }"
                solo/>
            </v-flex>
            <v-flex md12>
              <div class="devConfigHeader">
                <label class="modal-label" >Device Configuration</label>
              </div>
              <add-device-config-table
                :rows="device.devConfigInput"
                @addRow="addDeviceConfigRow"
                @deleteRow="deleteDeviceConfigRow"/>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="clearDataAndClose()" class="modal-cta">Cancel</v-btn>
        <v-btn text @click="submit" class="modal-cta">Save Changes</v-btn>
      </v-card-actions>    
      <v-card-text>
        <device-history-table
          v-if="hasHistory"
          :rows="deviceHistory"
          :pagination="pagination"
          @updateSort="updateDeviceHistorySort"
          @pageInfo="handleDeviceHistoryPagination"/>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  TRUE_OR_FALSE,
  DEV_CONFIG_XML_VALUES,
  DEVICE_HISTORY_SORTBY
} from "../../config/config.js";
import selectWithButton from "../../components/controls/SelectWithButton";
import { mapGetters } from "vuex";
import AddDeviceConfigTable from "./AddDeviceConfigTable.vue";
import DeviceHistoryTable from "./DeviceHistoryTable.vue";

export default {
  name: "addDevice",
  components: {
    selectWithButton,
    AddDeviceConfigTable,
    DeviceHistoryTable
  },
  props: {
    isOpen: Boolean,
    canSubmit: Boolean,
    device: Object,
    deviceHistory: Array,
    pagination: Object
  },
  data() {
    return { 
      TRUE_OR_FALSE: TRUE_OR_FALSE,
      DEV_CONFIG_XML_VALUES: DEV_CONFIG_XML_VALUES,
      DEVICE_HISTORY_SORTBY: DEVICE_HISTORY_SORTBY,
      error: null,
      lengthRegex: new RegExp(/^(?=.{1,50}$)/)
    };
  },
  computed: {
    ...mapGetters([]),
    modalTitle() {
      return "Add Device";
    },
    hasHistory() {
      return this.deviceHistory.length > 0;
    }
  },
  methods: {
    clearDataAndClose(){
      this.error = null;
      this.$emit("close");
    },
    submit() {
      this.$validator.validateAll()
        .then(valid => {
          if (valid) { 
            if (this.device.devConfigInput.length >= 1 && this.device.devConfigInput[0].type != null && this.device.devConfigInput[0].value != null && this.device.devConfigInput[0].description != null)
              this.device.devConfig = this.createDeviceXML();

            this.$emit("submit", this.device);
            this.error = null;
            this.$store.commit("displayStatus", { message: "Success! ", level: "success" });
          }
          else
            this.error = "Failed input validation.";
        });
    },
    addDeviceConfigRow() 
    {
      this.device.devConfigInput.push(
        {
          id: this.device.devConfigInput.length + 1,
          type: null,
          value: null,
          description: null,
        }
      );
    },
    deleteDeviceConfigRow(rowId) 
    {
      if (this.device.devConfigInput.length > 1) {
        var filteredArray = this.device.devConfigInput.filter(function(e) { return e.id != rowId })
        for (var i = 0; i < filteredArray.length; i++) 
          filteredArray[i].id = i + 1;
        this.device.devConfigInput = filteredArray;
      }
      else 
        this.device.devConfigInput = [
          {
            id: 1,
            type: null,
            value: null,
            description: null,
          }
        ];
    },
    createDeviceXML() 
    {
      var xml = "<AxisDEV_XML>";
      var magValIndex = 1;
      for (var i = 0; i < this.device.devConfigInput.length; i++) 
      {
        if (this.device.devConfigInput[i].type && this.device.devConfigInput[i].description && this.device.devConfigInput[i].value) 
        {
          if (this.device.devConfigInput[i].type == 2) 
          {
            xml += "<CONFIG TYPE=\"" + DEV_CONFIG_XML_VALUES.find(e => e.value == this.device.devConfigInput[i].type).text + "\" VALUE=\"" + this.device.devConfigInput[i].value +  "\" DESC=\"" + this.device.devConfigInput[i].description + "\" INDEX=\"" + magValIndex + "\" />";
            magValIndex += 1;
          }
          else
            xml += "<CONFIG TYPE=\"" + DEV_CONFIG_XML_VALUES.find(e => e.value == this.device.devConfigInput[i].type).text + "\" VALUE=\"" + this.device.devConfigInput[i].value +  "\" DESC=\"" + this.device.devConfigInput[i].description + "\" />";
        }
      }
      xml += "</AxisDEV_XML>";
      return xml;
    },
    updateDeviceHistorySort(data) {
        this.$emit("updateDeviceHistorySort", data);
    },
    handleDeviceHistoryPagination(data) {
        this.$emit("handleDeviceHistoryPagination", data);
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-axis-logo {
  width: 60px;
}

.inputField {
  max-width: 400px;
}

.error{
  text-align: center;
}
.devConfigHeader{
    border-bottom: #7f7f7f 1px solid;
    margin-bottom: 20px;
  }

.device-dialog 
{
  max-height: 750px;
}
</style>